import { render, staticRenderFns } from "./FxQuotes.vue?vue&type=template&id=d900d53c&lang=pug&"
import script from "./FxQuotes.vue?vue&type=script&lang=js&"
export * from "./FxQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ny5dev1b/rgirap/thgit/web.app/fxquotes/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d900d53c')) {
      api.createRecord('d900d53c', component.options)
    } else {
      api.reload('d900d53c', component.options)
    }
    module.hot.accept("./FxQuotes.vue?vue&type=template&id=d900d53c&lang=pug&", function () {
      api.rerender('d900d53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/FxQuotes.vue"
export default component.exports